export const tedeeConfig = {
  common: {
    saving: "Guardando...",
    connected: "Conectado",
    disconnected: "Desconectado",
    lockFallbackNamed: "Cerradura {id}",
    deviceFallbackNamed: "Tedee Device {id}",
    unitFallback: "Unidad",
    unitFallbackNamed: "Unidad {id}",
  },

  credentials: {
    title: "Configuración de Tedee",
    apiVersionInUse: "Versión API en uso:",
    savedKey: "Clave guardada",
    noKey: "Sin clave",
    keyLabel: "Personal Access Key",
    keyPlaceholderSaved: "•••••••• (ya guardada, opcional cambiar)",
    keyPlaceholderNew: "Ingresa tu Personal Access Key de Tedee",
    keyHintSaved: "Puedes dejarlo vacío si ya tienes una clave guardada.",
    keyHintNew: "Obtén tu clave desde el portal de Tedee.",
    testing: "Probando...",
    test: "Probar Conexión",
    save: "Guardar credenciales",
  },

  selector: {
    title: "Selector de cerraduras para esta propiedad",
    subA: "Selecciona solo las cerraduras que aplican a",
    subBold: "esta propiedad",
    subB: ". Luego, en el PMS verás únicamente las seleccionadas.",
    selectedCount: "{count} seleccionada(s)",
    hintNoKeyA: "Ingresa tu Personal Access Key y pulsa",
    hintNoKeyBold: "Probar Conexión",
    hintNoKeyB: "para cargar tus cerraduras.",
    emptyDevices:
      "No hemos encontrado ninguna cerradura ni verja en tu cuenta de Tedee. Comprueba que el dispositivo esté dado de alta y compartido con la cuenta cuya clave has guardado arriba.",
    placeholder: "Selecciona cerraduras…",
    summaryCount: "{count} cerradura(s) seleccionada(s)",
    summaryEmpty: "Ninguna cerradura seleccionada",
    save: "Guardar cerraduras de esta propiedad",
  },

  pms: {
    title: "Control y asignación (PMS)",
    subA:
      "Aquí solo aparecen las cerraduras que guardaste para esta propiedad. Asigna cada una a",
    subBold1: "Puerta principal",
    subOr: "o",
    subBold2: "Unidad",
    subEnd: ".",
    assignedCount: "{count} asignada(s)",
    empty: {
      A: "Aún no tienes cerraduras guardadas para esta propiedad. Usa el",
      bold: "Selector",
      B: "arriba y luego guarda.",
    },
    assignmentLabel: "Asignación",
    assignmentNone: "Sin asignar",
    assignmentGate: "Puerta principal (Gate)",
    assignmentCommon: "Puerta principal (común)",
    assignmentUnit: "Puerta de apartamento",
    hintNone: "No se controlará desde PMS.",
    hintGate: "Gate: solo se puede pulsar para abrir (no soporta lock/PIN).",
    hintUnit: "Quedará asociada a esta propiedad para control/PINs.",
    unitLabel: "Unidad / Alojamiento",
    unitSelect: "Selecciona una unidad",
    unitHint: "Selecciona qué unidad abre esta cerradura.",
    nameLabel: "Nombre (opcional)",
    namePlaceholder: "Ej: Puerta principal / Apt 101",
    nameHint:
      "Este nombre se guarda al volver a guardar el selector de cerraduras.",
    actions: {
      lock: "Bloquear",
      unlock: "Desbloquear",
      createPin: "Crear PIN",
      pinHistory: "Historial de PINs",
      openGate: "Abrir portal (pulso)",
      refresh: "Actualizar estado",
    },
    save: "Guardar asignación",
    tipA: "Tip: Asigna puerta principal o unidad y pulsa",
    tipBold: "Guardar asignación",
    tipB: ". Los botones se habilitan cuando el dispositivo esté asignado.",
  },

  pinHistory: {
    title: "Historial de PINs",
    loading: "Cargando historial…",
    empty: "No hay PINs registrados para esta cerradura.",
    colAlias: "Alias",
    colPin: "PIN",
    colValidity: "Vigencia",
    colState: "Estado",
    createdPrefix: "Creado:",
    fromLabel: "Desde:",
    toLabel: "Hasta:",
    revokeTitle: "Eliminar / Revocar PIN",
    noteA: '* "Activo" se calcula comparando la fecha/hora actual con',
    noteMid: "y",
    noteEnd: ".",
    close: "Cerrar",
  },

  pinModal: {
    title: "Crear PIN",
    nameLabel: "Nombre / Etiqueta",
    namePlaceholder: "Ej: Limpieza / Huésped / Técnico",
    pinLabel: "PIN",
    pinPlaceholder: "6 dígitos",
    generateTitle: "Generar",
    pinHint: "Si lo dejas vacío, el backend genera uno.",
    modeLabel: "Modo",
    modeTimeLimited: "Con fecha",
    modeOngoing: "Sin fecha (hasta revocar)",
    validFrom: "Válido desde",
    validTo: "Válido hasta",
    tipLabel: "Tip:",
    tipText: "Para huésped, usa un PIN con fechas de check-in/check-out.",
    cancel: "Cancelar",
    creating: "Creando...",
    create: "Crear PIN",
  },

  toast: {
    noLocksFound: "No se encontraron cerraduras (type 2/5) en Tedee.",
    loadStatusError: "No se pudo cargar locks-status",
    loadStatusError2: "Error cargando locks-status",
    needKey: "Debes ingresar un Personal Access Key o tener una clave guardada.",
    connectionOk: "Conexión exitosa. {count} dispositivo(s) encontrado(s).",
    testError: "Error al probar la conexión",
    needValidKey:
      "Debes ingresar un Personal Access Key válido (mínimo 10 caracteres).",
    credentialsSaved: "Credenciales guardadas correctamente",
    saveCredentialsError: "Error al guardar credenciales",
    saveCredentialsErrorPrefix: "Error al guardar credenciales: ",
    needOneDevice: "Debes seleccionar al menos un dispositivo para esta propiedad.",
    devicesSaved: "Dispositivos guardados para esta propiedad",
    devicesSaveError: "No se pudo guardar los dispositivos",
    saveErrorPrefix: "Error al guardar: ",
    gateNoLock:
      "Gate (type 5) no soporta bloquear. Solo se puede pulsar para abrir.",
    locked: "Cerradura bloqueada",
    lockError: "No se pudo bloquear",
    lockError2: "Error al bloquear",
    gateOpened: "Portal abierto (pulso)",
    unlocked: "Cerradura desbloqueada",
    unlockError: "No se pudo desbloquear",
    unlockError2: "Error al desbloquear",
    needUnitForApartment:
      "Selecciona la unidad para las cerraduras asignadas como 'Puerta de apartamento'.",
    bindingsSaved: "Asignación guardada correctamente",
    bindingsSaveError: "No se pudo guardar la asignación",
    bindingsSaveErrorPrefix: "Error al guardar asignación: ",
    gateNoPin: "Gate (type 5) no soporta PINs.",
    assignFirst:
      "Asigna primero la cerradura (puerta principal o unidad) y guarda para habilitar control.",
    needPinName: "Debes indicar un nombre/etiqueta para el PIN.",
    needValidDates: "Debes indicar válido desde y válido hasta.",
    pinCreated: "PIN creado correctamente",
    pinCreateError: "No se pudo crear el PIN",
    pinCreateError2: "Error creando PIN",
    gateNoPinHistory: "Gate (type 5) no soporta historial de PINs.",
    historyLoadError: "No se pudo cargar el historial",
    historyLoadError2: "Error cargando historial",
    noProviderPinId:
      "Este PIN no tiene provider_pin_id. No se puede revocar en Tedee.",
    pinRevoked: "PIN revocado",
    revokeError: "No se pudo revocar",
    revokeError2: "Error revocando PIN",
  },

  confirm: {
    revokePin: '¿Seguro que deseas revocar/eliminar el PIN "{alias}"?',
  },

  pinState: {
    active: "Activo",
    upcoming: "Próximo",
    expired: "Expirado",
    revoked: "Revocado",
    none: "Sin fecha",
  },
};
